import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {
  course: {},
};

const slice = createSlice({
  name: 'courseDetails',
  initialState,
  reducers: {
    setCourse: (state, action: PayloadAction<any>) => {
      state.course = action.payload;
    },
  },
});

export const api = createApi({
  reducerPath: 'courseDetailsApi',
  baseQuery,
  tagTypes: ['course', 'course_categories', 'course_tags'],
  endpoints: builder => ({
    getCourseDetail: builder.query({
      query: id => ({
        url: endpoints.COURSES + '/' + id,
        method: 'GET',
      }),
    }),
    getCourseContent: builder.query({
      query: id => ({
        url: endpoints.COURSES + '/' + id + '/content',
        method: 'GET',
      }),
    }),
    addTopic: builder.mutation({
      query: data => ({
        url: endpoints.COURSES + '/topics/add',
        method: 'POST',
        body: data,
      }),
    }),

    getCourseReview: builder.query({
      query: id => ({
        url: endpoints.COURSE + '/' + id + '/reviews',
        method: 'GET',
      }),
    }),
    lecturePreview: builder.mutation<any, any>({
      query: body => {
        return {
          url: endpoints.COURSES + `/preview-lecture`,
          method: 'POST',
          body,
        };
      },
    }),
  }),
});

export const { actions: courseDetailsActions } = slice;

export const useCourseDetailsSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: courseDetailsActions,
    useLazyGetCourseDetailQuery: api.useLazyGetCourseDetailQuery,
    useLazyGetCourseContentQuery: api.useLazyGetCourseContentQuery,
    useAddTopicMutation: api.useAddTopicMutation,
    useCourseReviewsQuery: api.useLazyGetCourseReviewQuery,
    useLecturePreviewMutation: api.useLecturePreviewMutation,
  };
};
